var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.faq ? 'default-faq' : 'blank-layout'},[_c('Nuxt'),_vm._v(" "),_c('portal-target',{attrs:{"name":"modal"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }